/** Why loading a student's plan alerts for the SCMP drawer failed. */
export type StudentPlanAlertsErrorReason =
  | 'missing-student'
  | 'invalid-response'
  | 'request-failed';

/**
 * Typed failure for the staff SCMP plan alerts drawer, carrying enough context to trace the request.
 */
export class StudentPlanAlertsError extends Error {
  readonly reason: StudentPlanAlertsErrorReason;
  readonly studentId?: string;
  readonly planId?: string;
  readonly status?: number;

  /**
   * @param reason - Failure category used by the UI and logs
   * @param context - Student/plan identifiers and optional HTTP status for tracing
   */
  constructor(
    reason: StudentPlanAlertsErrorReason,
    context: { studentId?: string; planId?: string; status?: number; cause?: unknown } = {}
  ) {
    super(`Unable to load plan alerts (${reason})`, { cause: context.cause });
    this.name = 'StudentPlanAlertsError';
    this.reason = reason;
    this.studentId = context.studentId;
    this.planId = context.planId;
    this.status = context.status;
  }
}
/** Explicit failure when saved recommendation students cannot be resolved from the roster. */
export class RecommendationStudentDetailsError extends Error {
  /**
   * @param reason - Whether tenant context or saved students are missing from the lookup
   */
  constructor(readonly reason: 'missing-context' | 'missing-students') {
    super(`Unable to load recommended student details (${reason})`);
    this.name = 'RecommendationStudentDetailsError';
  }
}
